export const COURSE_OPTIONS = [
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "locale", label: "Lang" },
]

export const DOC_OPTIONS = [
  {
    id: "doc_name",
    label: "Name",
  },
  {
    id: "doc_type",
    label: "Type",
  },
  { id: "locale", label: "Lang" },
]
